import { datadogRum } from '@datadog/browser-rum';
import { environment } from './environments/environment';
import { scrubRumEvent } from './datadog-rum-scrub';

export function initDatadogRum(): void {
  const cfg = environment.datadogRum;
  if (!cfg || !cfg.enabled) {
    return;
  }

  datadogRum.init({
    applicationId: cfg.applicationId,
    clientToken: cfg.clientToken,
    site: cfg.site,
    service: cfg.service,
    env: cfg.env,
    version: environment.angularJSconstants.VERSION,
    sampleRate: cfg.sessionSampleRate,
    replaySampleRate: cfg.sessionReplaySampleRate,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: scrubRumEvent,
  });
}
